import React, { useEffect, useState } from "react";
import { getNewsletters, updateNewsletterApproval } from "../services/firestoreService";
import PageHead from "../components/common/PageHead";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faFileExport } from '@fortawesome/free-solid-svg-icons';
import * as XLSX from "xlsx";

const Newsletters = () => {
  const [newsletters, setNewsletters] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchNewsletters = async () => {
      try {
        const newsletterData = await getNewsletters();
        setNewsletters(newsletterData);
      } catch (err) {
        setError("Failed to load newsletters.");
      } finally {
        setLoading(false);
      }
    };
    fetchNewsletters();
  }, []);

  const handleApproval = async (id, currentStatus) => {
    try {
      const newStatus = !currentStatus;
      await updateNewsletterApproval(id, newStatus);
      setNewsletters((prev) =>
        prev.map((n) => (n.id === id ? { ...n, approved: newStatus } : n))
      );
    } catch (err) {
      setError("Failed to update approval status.");
    }
  };

  const exportToExcel = () => {
    const exportData = newsletters.map(({ email, subscribedAt, approved }) => ({
      Email: email,
      "Subscribed At": new Date(subscribedAt?.seconds * 1000).toLocaleString(),
      Approved: approved ? "Yes" : "No",
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Newsletters");
    XLSX.writeFile(workbook, "newsletters.xlsx");
  };

  if (loading) return <p className="text-center mt-4">Loading newsletters...</p>;
  if (error) return <p className="text-center mt-4 text-red-500">{error}</p>;

  return (
    <>
      <PageHead name="Newsletter Subscriptions" />
      <div className="container mx-auto p-6 max-w-screen-lg">
        <div className="flex justify-end mb-4">
          <button
            onClick={exportToExcel}
            className="bg-primary px-4 py-2 text-white rounded hover:bg-secondary transition"
          >
            <FontAwesomeIcon icon={faFileExport} className="mr-2" /> Export
          </button>
        </div>

        <div className="overflow-x-auto">
          <table className="min-w-full bg-gray-100 table-auto text-left my-6 border border-gray-600">
            <thead className="bg-gray-200 text-gray-700 text-lg">
              <tr>
                <th className="border border-gray-600 px-4 py-2 w-1/12">#</th>
                <th className="border border-gray-600 px-4 py-2 w-1/4">Email</th>
                <th className="border border-gray-600 px-4 py-2 w-1/4">Subscribed At</th>
                <th className="border border-gray-600 px-4 py-2 w-1/6">Approved</th>
                <th className="border border-gray-600 px-4 py-2 w-1/6">Action</th>
              </tr>
            </thead>

            <tbody>
              {newsletters.length > 0 ? (
                newsletters.map((newsletter, index) => (
                  <tr key={newsletter.id} className="border-b border-gray-600 hover:bg-gray-100 transition">
                    <td className="h-20 px-4 border border-gray-600 text-center">{index + 1}</td>
                    <td className="h-20 px-4 border border-gray-600">{newsletter.email}</td>
                    <td className="h-20 px-4 border border-gray-600">
                      {new Date(newsletter.subscribedAt?.seconds * 1000).toLocaleString()}
                    </td>
                    <td className="h-20 px-4 border border-gray-600">
                      {newsletter.approved ? "Yes" : "No"}
                    </td>
                    <td className="h-20 px-4 border border-gray-600 text-center">
                      <button
                        onClick={() => handleApproval(newsletter.id, newsletter.approved)}
                        className={`p-2 rounded ${
                          newsletter.approved
                            ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                            : "text-green-600 hover:bg-green-600 hover:text-white"
                        }`}
                        disabled={newsletter.approved}
                        title={newsletter.approved ? "Already Approved" : "Approve"}
                      >
                        {!newsletter.approved && <FontAwesomeIcon icon={faCheck} />}
                        {newsletter.approved && <small>Approved</small>}
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5" className="text-center py-4">No newsletter subscriptions found</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default Newsletters;
